"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_RESEARCH_VIEWS = exports.DEFAULT_RESEARCH_VIEW_SCHEMA_VERSION = void 0;
/** Saved Research-view payload version understood by the current web deserializer. */
exports.DEFAULT_RESEARCH_VIEW_SCHEMA_VERSION = 4;
/**
 * Canonical brand-shared views. Queries use the public URL vocabulary so the migration, API seed,
 * and web preset reader share one durable definition.
 *
 * "Following" sits first: Discover (all ads) is the new Research suite default landing, and the
 * followed-brands-only feed lives as this named saved view. The sidebar orders views by
 * `createdAt ASC`; the DB backfill inserts "Following" with `createdAt = 1970-01-01` so it always
 * precedes any user-created view.
 *
 * EVERY canonical view carries `follow-brands-only=true`: the seeded views curate the brands a
 * team chose to follow, not the whole library — Discover (the unfiltered default landing) is
 * where all-ads browsing lives. Changing this key here requires a paired ResearchView data
 * migration (see 20260903093000 and its successor) or existing brands' views drift from what
 * new brands are seeded with.
 */
exports.DEFAULT_RESEARCH_VIEWS = [
    {
        name: 'Following',
        data: {
            schemaVersion: exports.DEFAULT_RESEARCH_VIEW_SCHEMA_VERSION,
            query: 'follow-brands-only=true',
        },
    },
    {
        name: 'Recent Active Ads',
        data: {
            schemaVersion: exports.DEFAULT_RESEARCH_VIEW_SCHEMA_VERSION,
            query: 'status=ACTIVE&sort-by=LONGEST_RUNNING&follow-brands-only=true',
        },
    },
    {
        name: 'Active Winners',
        data: {
            schemaVersion: exports.DEFAULT_RESEARCH_VIEW_SCHEMA_VERSION,
            query: 'status=ACTIVE&performance-score-min=70&sort-by=HIGHEST_PERFORMANCE&follow-brands-only=true',
        },
    },
    {
        name: 'New Launches',
        data: {
            schemaVersion: exports.DEFAULT_RESEARCH_VIEW_SCHEMA_VERSION,
            query: 'time-range-type=LAST_14_DAYS&follow-brands-only=true',
        },
    },
    {
        name: 'Killed Fast',
        data: {
            schemaVersion: exports.DEFAULT_RESEARCH_VIEW_SCHEMA_VERSION,
            query: 'status=INACTIVE&days-running-max=7&stopped-within-days=30&sort-by=RECENTLY_STOPPED&follow-brands-only=true',
        },
    },
];
